'use client';

import { usePathname } from 'next/navigation';

import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { useCustomRouter } from '@/hooks/useCustomRouter';

interface ReviewDetailControllerProps {
  reviewId?: number;
}

export const ReviewDetailController = ({
  reviewId,
}: ReviewDetailControllerProps) => {
  const router = useCustomRouter();
  const pathname = usePathname();

  const isOpen = Boolean(reviewId);

  const handleClose = () => {
    const currentSearchParams = new URLSearchParams(location.search);
    currentSearchParams.delete('detailReviewId');

    const search = currentSearchParams.toString();

    router.replace(`${pathname}${search ? `?${search}` : ''}`, {
      scroll: false,
    });
  };

  return (
    <ReviewDetailSessionPortal
      open={isOpen}
      onClose={handleClose}
      reviewId={reviewId}
    />
  );
};
